(() => {
  const desktopQuery = "(min-width: 992px)";

  function initGridCascadeSwiper(section) {
    if (section.dataset.swiperInitialized === "true" || !window.Swiper) return;

    const swiperElement = section.querySelector("[data-grid-cascade-swiper]");
    const carousel = section.querySelector("[data-grid-cascade-carousel]");
    const progress = section.querySelector("[data-grid-cascade-progress]");
    const count = section.querySelector("[data-grid-cascade-count]");
    const prevButton = section.querySelector("[data-grid-cascade-prev]");
    const nextButton = section.querySelector("[data-grid-cascade-next]");

    if (!swiperElement || !carousel) return;

    const total = swiperElement.querySelectorAll(".swiper-slide").length;
    if (!total) return;

    carousel.hidden = false;

    const updateIndicator = (swiper) => {
      const perView = Math.max(
        1,
        Math.floor(Number(swiper.params.slidesPerView)) || 1,
      );
      const steps = Math.max(1, total - perView + 1);
      const current = Math.min(swiper.activeIndex + 1, steps);

      if (progress) progress.style.width = `${(current / steps) * 100}%`;
      if (count) count.textContent = `${current}/${steps}`;
      if (prevButton) prevButton.disabled = swiper.isBeginning;
      if (nextButton) nextButton.disabled = swiper.isEnd;
    };

    const swiper = new window.Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 500,
      autoHeight: true,
      watchOverflow: true,
      grabCursor: total > 1,
      a11y: { enabled: true },
      breakpoints: {
        768: {
          slidesPerView: 2.15,
          spaceBetween: 24,
          autoHeight: false,
        },
      },
      on: {
        init: updateIndicator,
        slideChange: updateIndicator,
        breakpoint: updateIndicator,
        resize: updateIndicator,
      },
    });

    if (prevButton) {
      prevButton.addEventListener("click", () => swiper.slidePrev());
    }

    if (nextButton) {
      nextButton.addEventListener("click", () => swiper.slideNext());
    }

    section.dataset.swiperInitialized = "true";
    section._gridCascadeSwiper = swiper;
  }

  function destroyGridCascadeSwiper(section) {
    if (section.dataset.swiperInitialized !== "true") return;

    const swiper = section._gridCascadeSwiper;
    if (swiper && typeof swiper.destroy === "function") {
      swiper.destroy(true, true);
    }

    const carousel = section.querySelector("[data-grid-cascade-carousel]");
    if (carousel) carousel.hidden = true;

    section.dataset.swiperInitialized = "false";
    section._gridCascadeSwiper = null;
  }

  function applyLayout(section, isDesktop) {
    if (isDesktop) {
      destroyGridCascadeSwiper(section);
      return;
    }

    loadSwiperCss();
    loadSwiperScript().then(() => initGridCascadeSwiper(section));
  }

  function bindSection(section) {
    if (section.dataset.gridCascadeBound === "true") return;
    section.dataset.gridCascadeBound = "true";

    const mediaQuery = window.matchMedia(desktopQuery);
    applyLayout(section, mediaQuery.matches);

    const handleBreakpointChange = (event) => {
      applyLayout(section, event.matches);
    };

    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", handleBreakpointChange);
    } else if (typeof mediaQuery.addListener === "function") {
      mediaQuery.addListener(handleBreakpointChange);
    }
  }

  function bootGridCascade(root = document) {
    if (root.matches?.(".custom-grid-cascade")) {
      bindSection(root);
    }

    root.querySelectorAll(".custom-grid-cascade").forEach(bindSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => bootGridCascade());
  } else {
    bootGridCascade();
  }

  document.addEventListener("shopify:section:load", (event) => {
    bootGridCascade(event.target);
  });
})();
